import NextLink from 'next/link';
import PropTypes from 'prop-types';
import { memo } from 'react';
import { twMerge } from 'tailwind-merge';

import Button from 'shopper/components/Button';
import Text from 'shopper/components/Text';

import { sendEvent } from 'lib/gtag';
import { toStoreOffersLink } from 'lib/links';
import placeholder from 'lib/placeholder';

import Checklist from './Checklist';
import StoreName from './StoreName';

const StoreInfo = ({
  className,
  gaEventCategory,
  hasPhysicalStore,
  isStoreCnpjValid,
  isStoreVerified,
  storeDescription,
  storeDomain,
  storeImage,
  storeMarketplace,
  storeName,
  storeParam,
}) => (
  <section className={twMerge('flex flex-col gap-y-4 lg:mr-32', className)}>
    <StoreName
      storeDomain={storeDomain}
      storeImage={storeImage}
      storeName={storeName}
    />
    <Checklist
      hasPhysicalStore={storeMarketplace?.hasPhysicalStore ?? hasPhysicalStore}
      isCnpjValid={storeMarketplace?.isMarketplaceCnpjValid ?? isStoreCnpjValid}
      isMarketplace={!!storeMarketplace}
      isVerified={storeMarketplace?.isMarketplaceVerified ?? isStoreVerified}
    />
    {storeName && <Text size="size2">{storeDescription}</Text>}
    {storeName && (
      <NextLink href={toStoreOffersLink(storeParam)} prefetch={false} passHref>
        <Button
          className="mt-2 pl-0 [&>span]:text-rd-primary-700 dark:[&>span]:text-rd-primary-700"
          size="size4"
          type="primary-ghost"
          onClick={() => {
            sendEvent({
              category: gaEventCategory,
              action: 'more_store_offers',
            });
          }}
        >
          {placeholder('actions.seeStoreOffers')}
        </Button>
      </NextLink>
    )}
  </section>
);

StoreInfo.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  gaEventCategory: PropTypes.string.isRequired,
  hasPhysicalStore: PropTypes.bool.isRequired,
  isStoreCnpjValid: PropTypes.bool.isRequired,
  isStoreVerified: PropTypes.bool.isRequired,
  storeDescription: PropTypes.string,
  storeDomain: PropTypes.string,
  storeImage: PropTypes.string,
  storeMarketplace: PropTypes.shape({
    isMarketplaceVerified: PropTypes.bool.isRequired,
    isMarketplaceCnpjValid: PropTypes.bool.isRequired,
    hasPhysicalStore: PropTypes.bool.isRequired,
  }),
  storeName: PropTypes.string.isRequired,
  storeParam: PropTypes.string.isRequired,
};

export default memo(StoreInfo);
